// @ts-ignore-file
import React, { PureComponent } from "react";

const { Jodit } = require("jodit");
//import Jodit from "jodit";
import createStyles from "@material-ui/styles/createStyles";
import withStyles from "@material-ui/core/styles/withStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import Chip from "@material-ui/core/Chip";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import MyPATDialog from "../../common/MyPATDialog";
import cx from "classnames";
import _, { divide } from "lodash";
import MyPATFileUpload from "../../common/MyPATFileUpload";
import {
  FormControl,
  FormControlLabel,
  Link,
  MenuItem,
  Radio,
  RadioGroup,
  TextField,
} from "@material-ui/core";
import MyPATUploader, { Attachment } from "../../common/MyPATUploader";
import { Error } from "@material-ui/icons";
import DropZone from "../../common/DropZone";
import MyPATUploadPreview, {
  convertFileOrUrlToPreviewItem,
} from "../../common/MyPATUploadPreview";
import * as XLSX from "xlsx";
import {
  Package,
  Template,
  TestDetail,
  TestSeriesCoursePlan,
} from "../types/interfaces/CourseBasicDetails";
import classNames from "classnames";
import MyPATSelect from "../../common/MyPATSelect";
import SearchBarWithChips from "../common/SearchBarWithChips";
import { bindActionCreators } from "redux";
import * as courseManagementActions from "../actions/courseManagementActions";
import { connect } from "react-redux";
import { ExistingScheduledTest } from "../types/interfaces/ExistingScheduledTest";
import { SCHEDULE_TEST_SAMPLE_FILE_URL } from "../Constants/constants";
import contentManagementService from "../service/courseManagementServices";
import dateService from "../../common/services/dateService";
import { MyPATMultiSearch } from "../../common";
import { TEST_TYPE_MAP } from "./coursePlan/addTestDialog/Constants/Constants";

const styles = (theme: Theme) =>
  createStyles({
    cancleBtn: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "19px",
      color: "#1d7dea",
      wordSpacing: 0.5,
      padding: "9px 25px",
    },
    doneBtn: {
      fontWeight: 600,
      fontSize: "14px",
      lineHeight: "19px",
      backgroundColor: "#1d7dea",
      color: "#fff",
      wordSpacing: 0.5,
      padding: "9px 25px",
      "&:hover": {
        backgroundColor: "#1d7dea",
        color: "#fff",
      },
    },
    chip: {
      border: "1px solid #1D7DEA",
      fontWeight: 600,
      fontSize: "12px",
      lineHeight: "16px",
      padding: "6px 24px",
      margin: "0px 12px 12px 0px",
      "&:hover": {
        color: "#fff",
      },
      "&:focus": {
        backgroundColor: "#1d7dea",
        color: "#fff",
      },
    },
    chipInactive: {
      backgroundColor: "transparent!important",
      color: "#1d7dea!important",
    },
    chipActive: {
      backgroundColor: "#1d7dea",
      color: "#fff",
    },
    dialogHeading: {
      fontSize: "16px",
      lineHeight: "22px",
      color: "#666",
      textAlign: "left",
      margin: "0px 0 12px 0",
    },
    minHeight: {
      minHeight: "325px",
    },
    editorWrapper: {
      width: "100%",
    },
    dragDropVideoContainer: {
      border: "1px dashed #D8D8D8",
      padding: "15px",
      textAlign: "center",
      borderRadius: "4px",
      width: "100%",
      margin: "30px 0 18px 0",
    },
    dragDropVideoText: {
      color: "#333",
      fontSize: "14px",
      fontWeight: 700,
      display: "inline-block",
    },
    fileInfo: {
      fontSize: 12,
      lineHeight: "16px",
      color: "#999",
      display: "block",
      fontWeight: "normal",
    },
    fileTypeInfo: {
      fontSize: 14,
      fontWeight: 600,
      color: "#666",
      textAlign: "center",
    },
    downloadSample: {
      fontSize: 14,
      fontWeight: 600,
      color: "#1d7dea",
      textAlign: "center",
      marginTop: 15,
      marginBottom: 28,
      cursor: "pointer",
    },
    customSelect: {
      "& > div:nth-of-type(1)": {
        display: "flex",
        alignItems: "center",
        borderRight: "1px solid #DFDFDF",
        height: "38px",
        padding: 0,
      },
    },
    testRadioGroup: {
      width: "100%",
      display: "inline-block",
      marginTop: "-10px",
      // textAlign: 'center',
      "& $label": {
        "&>:nth-child(2)": {
          fontSize: 16,
          fontWeight: 400,
          color: "#333",
        },
      },
    },
    uploadPreview: {
      "&>:first-child": {
        justifyContent: "center",
        "&>:first-child": {
          "&>:first-child": {
            margin: "16px 0",
          },
        },
      },
    },
    searchBarChips: {
      height: "auto",
      "&>div:nth-of-type(1)": {
        border: "1px solid #dfdfdf",
        borderRadius: 4,
        padding: "0 0 0 15px",
        "&>div:nth-of-type(1)": {
          "&>div:nth-of-type(1)": {
            "&>div:nth-of-type(1)": {
              "&>div:nth-of-type(1)": {
                overflow: "initial",
                "&>div:last-of-type": {
                  marginTop: "initial !important",
                  lineHeight: "30px",
                },
              },
            },
          },
        },
      },
      "& svg": {
        cursor: "pointer",
      },
    },
    inputLable: {
      fontSize: 16,
      color: "#666",
      marginBottom: 8,
      fontWeight: 600,
      display: "inline-block",
    },
  });

interface Props {
  classes: any;
  onClose: any;
  onDone: any;
  open: boolean;
  templates: Template[];
  existingScheduledTests: TestDetail[];
  fetchExistingScheduledTests: Function;
  addExistingTest: Function;
  selectedGoalsForTestSeries: any;
}

enum sheetColumnsNames {
  Duration = "duration",
  MaxAttempt = "maxAttempts",
  ScheduleDate = "startDate",
  ScheduleEndDate = "endDate",
  Syllabus = "syllabus",
  TestName = "name",
  Type = "type",
  RevisionTime = "revisionTime",
  TestId = "testId",
  QuestionsCount = "questionsCount"
}

interface State {
  isLoading: boolean;
  attachments: Attachment[];
  addTestType: string;
  showDragnDropDialog: boolean;
  testSeries: TestDetail[];
  selectedTemplate: any;
  scheduleTestSuggestions: any[];
  selectedScheduleTests: TestDetail[];
  activeGoals: any[];
  goalId: string;
  activeCourses: any[];
  courseId: string;
  modifySelectedTestSuggestions: any[];
  selectCourseId:any;
  scheduledTestMap:any;
}
const ALLOWED_ORDER_NOTE_ATTACHMENTS = [
  "doc",
  "docx",
  "xls",
  "xlsx",
  "msword",
  "vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "vnd.openxmlformats-officedocument.wordprocessingml.document",
];
class BulkAddTestPopUp extends PureComponent<Props, State> {
  upload: any = null;
  constructor(props: Props) {
    super(props);
    this.state = {
      isLoading: false,
      attachments: [],
      addTestType: "upload",
      showDragnDropDialog: true,
      testSeries: [],
      selectedTemplate: "",
      scheduleTestSuggestions: [],
      selectedScheduleTests: [],
      activeGoals: [],
      goalId: "",
      activeCourses: [],
      courseId: "",
      modifySelectedTestSuggestions: [],
      selectCourseId:{},
      scheduledTestMap:{}
    };
  }
  componentDidMount() {
    this.setActiveGoals(this.props.selectedGoalsForTestSeries);
  }

  setActiveGoals = (goalData: any) => {
    this.setState({
      activeGoals: goalData,
    });
  };

  componentDidUpdate(prevProps: Props) {
    if (
      this.props.selectedGoalsForTestSeries.length &&
      prevProps.selectedGoalsForTestSeries !==
        this.props.selectedGoalsForTestSeries
    ) {
      this.setActiveGoals(this.props.selectedGoalsForTestSeries);
    }
  }

  getScheduledTests = async (courseId: string) => {
    const response = await contentManagementService.fetchExistingScheduledTests(
      courseId
    );
    const existingScheduledTests = response;
    this.modifyScheduleTest(existingScheduledTests);
  };

  getTemplates = async (id: string) => {
    const param = {
      type: "testSeries",
      goals: id,
      pagination: false,
    };
    const response = await contentManagementService.getPackageTemplates(param);
    const activeCourses = response.packages;
    this.setState({ activeCourses: response.responseObject.packages });
  };

  handleGoalSelect = (event: any) => {
    if (event.target.value) {
      const val=event.target.value;
      
      // Set to all zero state on Goal Change
      this.setState({ goalId: event.target.value, activeCourses:[],selectCourseId:{},
                     modifySelectedTestSuggestions:[],scheduleTestSuggestions:[] },()=>{
                      this.getTemplates(val);
                      console.log(this.state.goalId);
                     }); 
    }
  };

  renderSelectGoalOptions = () => {
    const { classes } = this.props;
    return (
      <>
        <Typography
          className={classes.inputLable}
          style={{ marginTop: "20px" }}
        >
          Select A Goal
        </Typography>
        <MyPATSelect
          fullWidthControl
          fullWidthInput
          onChange={this.handleGoalSelect}
        >
          <option value={""}>{"Select Goal"}</option>
          {this.state.activeGoals.map((goal: any) => (
            <option key={goal.courseName} value={goal.courseId}>
              {goal.courseName}
            </option>
          ))}
        </MyPATSelect>
      </>
    );
  };

  renderSelectCourseOptions = () => {
    const { classes } = this.props;
    const { activeCourses } = this.state;
    return (
      <>
        <Typography className={classes.inputLable}>Select A Course</Typography>
        {/* <MyPATSelect fullWidthControl fullWidthInput onChange={this.handleCourseChange}>
          <option value={''}>{'Select Course'}</option>
          {activeCourses &&
            activeCourses.length &&
            activeCourses.map((course: any) => (
              <option key={course.name} value={course.coursePlanId._id}>
                {course.name}
              </option>
            ))}
        </MyPATSelect> */}
        <MyPATMultiSearch
          options={activeCourses}
          labelKey="name"
          valueKey="_id"
          onChange={this.handleCourseChange}
          values={this.state.selectCourseId}
          isSearchAble
          showAllOptionsOnFocus
          // isCustomFilter
          // filtredFunction={this.getSearchResult}
          name="course"
          placeholderText="Search Courses"
          // error={error.creator.showError}
          // errorText={error.creator.errorText}
        />
      </>
    );
  };

  handleCourseChange = (option: any) => {
    const courseId=_.get(option,"coursePlanId._id","");
    this.setState({ courseId:option._id ,selectCourseId:option,modifySelectedTestSuggestions:[]});
    this.getScheduledTests(courseId);
  };

  setAttachments = (attachments: Attachment[]) => {
    this.setState({
      attachments,
    });
  };

  handleAttachments = async () => {
    try {
      const { attachments } = this.state;
      //   const { questionId } = this.props;
      //   if (!attachments || attachments.length === 0) {
      //     return [];
      //   }

      //   const promiseArr = attachments.map((attachment) => {
      //     return this.handleSingleAttachment(attachment, questionId!);
      //   });
      //   const urls = await Promise.all(promiseArr);
      //   return urls;
    } catch (error) {
      return Promise.reject(error.message);
    }
  };
  readExcel = (file: any) => {
    const promise = new Promise((resolve: any, reject: any) => {
      const fileReader = new FileReader();
      fileReader.readAsArrayBuffer(file);

      fileReader.onload = (e: any) => {
        const bufferArray = e.target.result;

        const wb = XLSX.read(bufferArray, { type: "buffer" });

        const wsname = wb.SheetNames[0];

        const ws = wb.Sheets[wsname];

        const data = XLSX.utils.sheet_to_json(ws);

        resolve(data);

        fileReader.onerror = (error) => {
          reject(error);
        };
      };
    });

    promise.then((d) => {
      console.log(d);
      this.filterTestSeriesData(d);
    });
  };

  filterTestSeriesData = (testSeries: any) => {
    const { goalId } = this.state;
    const validateTestId: any = [];
    let newTestSeries: TestDetail[] = [];
    testSeries.map((test: any) => {
      const newTest: any = {};
      if (test["Test Id"]) {
        validateTestId.push({
          testId: test["Test Id"],
        });
      }
      const keys = Object.keys(test);
      for (let key of keys) {
        let data = test[key];
        key = key.split(" ").join("");
        // @ts-ignore
        const keyActualName: string = sheetColumnsNames[key];
        if (keyActualName) {
          if (keyActualName === "type") {
            data = data.toLowerCase();
            if (TEST_TYPE_MAP.hasOwnProperty(data)) {
              data = TEST_TYPE_MAP[data];
            }
          }
          if (keyActualName === "startDate" || keyActualName === "endDate") {
            data = dateService.dateYMDHHMMSSToISO(data);
            console.log("DATE ", data);
          }
          newTest[keyActualName] = data;
        }
      }
      newTestSeries.push(newTest);
    });
    newTestSeries = newTestSeries.filter((test: any) => {
      for(const [field, value] of Object.entries(test)) {
        if(typeof value !== 'string' || value.trim().length > 0) {
          return true;
        }
      }
      return false;
    })
    this.props.onDone(validateTestId, newTestSeries, goalId);
    
  };

  handleFile = (Files: Attachment[]) => {
    this.props.onClose();
    this.readExcel(Files[0]);
  };

  handleRadio = () => {
    const { classes } = this.props;
    const { addTestType } = this.state;
    return (
      <div className={classes.root}>
        <Grid container justify="space-between">
          <RadioGroup
            name="addTestType"
            classes={{
              root: classes.testRadioGroup,
            }}
            className={classes.courseRadioGroup}
            onChange={(_: any, value: string) =>
              this.setState({ addTestType: value })
            }
            value={addTestType}
          >
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              label={"Upload Scheduled Tests"}
              value={"upload"}
            />
            <FormControlLabel
              control={
                <Radio
                  color="primary"
                  classes={{ root: classes.testRadioRoot }}
                />
              }
              value={"import"}
              label={"Import Existing Tests"}
            />
          </RadioGroup>
        </Grid>
      </div>
    );
  };

  handleDone = async () => {
    // const { issueArea, issueDescription, attachments } = this.state;
    try {
      this.setState({
        isLoading: true,
      });

      this.props.onDone();
    } catch (error) {
      this.setState({
        isLoading: false,
      });
    }
  };

  handleTemplateChange = (event: any) => {
    console.log("TARGET", event.target.value);
    const { value, name } = event.target;
    this.setState({ selectedTemplate: event.target.value }, () => {
      this.props.fetchExistingScheduledTests(value);
    });
  };

  handleDownloadClick = () => {
    const url: string = SCHEDULE_TEST_SAMPLE_FILE_URL;
    window.open(url, "_blank");
  };

  renderSelectTemplateOptions = () => {
    let options = [];
    const { templates, classes } = this.props;
    options.push(<option value={""}>{"Select Course"}</option>);
    // let mockData=[{
    //   "_id": "606c9ec64b60e26a187d9e41",
    //   "name": "IIT-JEE- TEST",
    //   "sku": "TTY-345-2024",
    //   "coursePlanId": {
    //     "_id": "606ca1a74b60e26a187d9e45",
    //     "phaseCount": 2,
    //     "phaseTestCount": 0
    //   },
    //   "expiryDate": "2021-05-30T18:30:00.000Z",
    //   "startDate": "2021-04-05T18:30:00.000Z"
    // },
    // {
    //   "_id": "606ec8dc4b60e26a187e0159",
    //   "name": "Advance-JEE-2021",
    //   "sku": "Adv-363-2024",
    //   "coursePlanId": {
    //     "_id": "606ec9c44b60e26a187e015b",
    //     "phaseCount": 2,
    //     "phaseTestCount": 0
    //   },
    //   "expiryDate": "2021-06-09T18:30:00.000Z",
    //   "startDate": "2021-04-07T18:30:00.000Z"
    // }]
    _.map(templates, (template: any, index: number) => {
      const value = _.get(template, "coursePlanId._id", "");
      options.push(
        <option key={index} value={value}>
          {template.name}
        </option>
      );
    });
    return options;
  };

  handleScheduledTest = (
    items: { value: any; label: string; id: string; isRemvable: boolean }[]
  ) => {
    console.log({ items });
    const{scheduledTestMap}=this.state;
    const allTestIds:string []=Object.keys(scheduledTestMap);
    const updatedSuggestions:any=[];
   
    const scheduleTests: TestDetail[] = [];
    if (items === null || items === undefined) {
      items = [];
    }
    const tempMap:any={};
    items.forEach((item) => {
      scheduleTests.push(item.value);
      tempMap[`${item.id}`]=item;
    });

    allTestIds.forEach((id:string)=>{
       if(!tempMap.hasOwnProperty(id)){
        const ob=scheduledTestMap[id];
        updatedSuggestions.push(ob);
       }
    })
    this.setState({
      selectedScheduleTests: scheduleTests,
      modifySelectedTestSuggestions: items,
      scheduleTestSuggestions:updatedSuggestions
    });
  };
  handleAddTestsBttn = () => {
    const { selectedScheduleTests } = this.state;
    this.props.addExistingTest(selectedScheduleTests);
    this.props.onClose();
  };
  renderImportTestform = () => {
    const { templates, classes, existingScheduledTests } = this.props;
    const {
      selectedTemplate,
      scheduleTestSuggestions,
      modifySelectedTestSuggestions,
    } = this.state;
    console.log({ modifySelectedTestSuggestions });
    return (
      <>
        <Grid container justify="center" spacing={8}>
          <Grid item xs={12} className={classes.customSelect}>
            {/* <Typography className={classes.inputLable}> Select A Course </Typography>
            <MyPATSelect
              style={{ width: '100%' }}
              name='template'
              className={classNames(classes.margin, classes.textField)}
              value={selectedTemplate}
              onChange={(e: any) => this.handleTemplateChange(e)}
              defaultValue={'none'}
              required
            >
              {this.renderSelectTemplateOptions()}
            </MyPATSelect> */}
            {this.renderSelectGoalOptions()}
          </Grid>
          <Grid item xs={12} className={classes.customSelect}>
            {this.renderSelectCourseOptions()}
          </Grid>

          <Grid item xs={12}>
            <Typography className={classes.inputLable}>
              Select Scheduled Tests
            </Typography>
            <SearchBarWithChips
              suggestions={scheduleTestSuggestions}
              placeholderText="Select Scheduled Tests"
              onSelection={this.handleScheduledTest}
              classes={{ root: classes.searchBarChips }}
              values={modifySelectedTestSuggestions}
            />
          </Grid>
        </Grid>
        <Grid style={{ textAlign: "center" }}>
          <Button
            variant="contained"
            color="primary"
            style={{
              marginTop: "23px",
            }}
            onClick={this.handleAddTestsBttn}
          >
            Add Tests
          </Button>
        </Grid>
      </>
    );
  };
  modifyScheduleTest = (existingScheduledTests: any) => {
    const scheduledTests: any = [];
    const scheduledTestMap:any={};
    existingScheduledTests &&
      existingScheduledTests.forEach((scheduledTest: any) => {
        let test = {
          label: scheduledTest.name || scheduledTest.displayName,
          value: { ...scheduledTest },
          id: scheduledTest._id || scheduledTest.testId,
          isRemovable: true,
        };
        scheduledTests.push(test);
        scheduledTestMap[`${test.id}`]=test;
      });
    console.log({ scheduledTests,scheduledTestMap });
    this.setState({ scheduleTestSuggestions: [...scheduledTests],
                     scheduledTestMap    });
  };

  render() {
    const { classes, onClose, open } = this.props;
    const {
      isLoading,
      addTestType,
      attachments,
      showDragnDropDialog,
    } = this.state;
    return (
      <>
        <MyPATDialog
          dialogOpen={open}
          dialogHasActions={true}
          dialogHeading={"Add Scheduled Tests"}
          isAlignCenter={true}
          customButtonVariant="withoutBorderCloseIcon"
          onDialogClose={onClose}
          isCustomBackground={false}
          isborderDialogAction={false}
          otherDialogProps={{
            fullWidth: true,
            // maxWidth: 'sm',
          }}
        >
          <Grid
            container
            direction="row"
            justify="flex-start"
            classes={classes.minHeight}
          >
            <Grid style={{ width: "100%" }}>{this.handleRadio()}</Grid>
            {addTestType === "upload" ? (
              <div className={classes.division} style={{ width: "100%" }}>
                {this.renderSelectGoalOptions()}
                <MyPATUploader
                  onChange={this.setAttachments}
                  allowedFileTypes={ALLOWED_ORDER_NOTE_ATTACHMENTS}
                  initialAttachments={attachments}
                >
                  {({
                    onItemRemove,
                    attachments,
                    loading,
                    errorMsg,
                    error,
                    handleFileChange,
                  }) => {
                    const list = attachments.map((attachment) =>
                      convertFileOrUrlToPreviewItem(attachment)
                    );
                    return (
                      <>
                        {attachments.length > 0 ? (
                          <Grid className={classes.uploadPreview}>
                            <MyPATUploadPreview
                              list={list}
                              readOnly={false}
                              onItemRemove={onItemRemove}
                            />

                            {error && (
                              <Grid item xs={12} justify="center">
                                <Typography
                                  className={classes.errorText}
                                  variant="caption"
                                  color="error"
                                >
                                  <Error />
                                  {errorMsg}
                                </Typography>
                              </Grid>
                            )}
                          </Grid>
                        ) : (
                          <DropZone onChange={handleFileChange}>
                            <Grid container justify="center">
                              <div className={classes.dragDropVideoContainer}>
                                <Grid container justify="center">
                                  <div style={{ width: "100%" }}>
                                    <img
                                      alt="Cancel video upload"
                                      src="/assets/svg/learn/cloudUpload.svg"
                                      onClick={(e) => {
                                        this.upload.value = "";
                                        this.upload.click();
                                      }}
                                      style={{ cursor: "pointer" }}
                                    />
                                  </div>
                                  <Typography
                                    className={classes.dragDropVideoText}
                                    component="div"
                                    variant="body1"
                                    align="center"
                                  >
                                    {false
                                      ? "uploading"
                                      : "Drag and drop a file"}
                                    <span className={classes.fileInfo}>
                                      Only upload .csv with max size 2 MB
                                    </span>
                                  </Typography>
                                  <input
                                    id="myInput"
                                    type="file"
                                    ref={(ref) => (this.upload = ref)}
                                    onChange={(event: any) => {
                                      //  let event={target:{files:this.upload}};
                                      handleFileChange(event);
                                    }}
                                    style={{ display: "none" }}
                                  />
                                </Grid>
                              </div>
                            </Grid>
                          </DropZone>
                        )}
                      </>
                    );
                  }}
                </MyPATUploader>
                <div className={classes.fileTypeInfo}>
                  Kindly upload data only in the sample formate .CSV
                </div>
                <div className={classes.downloadSample}>
                  <a onClick={this.handleDownloadClick}>
                    <img
                      alt="Download"
                      src="/assets/svg/learn/downloadIcon.svg"
                    />{" "}
                    Download Sample Format
                  </a>
                  {/* <Link href="../../../../../ScheduleCreate(3).xlxs" target="_blank" download>Download Sample Format</Link> */}
                </div>
                <Button
                  variant="contained"
                  color="primary"
                  style={{
                    marginLeft: "212px",
                    marginTop: "13px",
                  }}
                  onClick={() => {
                    this.handleFile(attachments);
                  }}
                  disabled={attachments.length === 0}
                >
                  Upload File
                </Button>
              </div>
            ) : (
              <Grid container justify="center">
                <Grid item xs={12}>
                  {this.renderImportTestform()}
                </Grid>
              </Grid>
            )}
          </Grid>
        </MyPATDialog>
      </>
    );
  }
}

const joditButtons = [
  "bold",
  "italic",
  "underline",
  "|",
  "font",
  "fontsize",
  "|",
  "ul",
];
const mapStateToProps = (state: any) => ({
  selectedGoalsForTestSeries:
    state.courseMangementData.contentManagementData.selectedGoalsForTestSeries,
  existingScheduledTests:
    state.courseMangementData.courseManagementReducer.existingScheduledTests,
});

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      fetchExistingScheduledTests:
        courseManagementActions.fetchExistingScheduledTests,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(BulkAddTestPopUp));
